import filter from '@/api/filter';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    this.getColumns();
  },
  methods: {
    getColumns() {
      let columns = [
        {
          title: '结算周期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
      ];
      // 商户
      if(this.userInfo.userType == 2) {
        columns.push({
          title: '结算单名称',
          align: 'center',
          key: 'reportName',
          minWidth: 250,
          slot: 'reportName'
        });
      }
      columns = columns.concat([
        {
          title: '发布状态',
          align: 'center',
          minWidth: 120,
          slot: 'releaseStatus'
        },
        {
          title: '机构数',
          align: 'center',
          key: 'orgNum',
          minWidth: 100
        },
        {
          title: '总人数',
          align: 'center',
          key: 'userNum',
          minWidth: 100
        },
        {
          title: '总单量',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '总保费',
          align: 'center',
          key: 'fee',
          minWidth: 120
        },
        {
          title: '基本法收益',
          align: 'center',
          key: 'methodIncome',
          minWidth: 120
        },
        {
          title: '基本法外基础费用',
          align: 'center',
          key: 'baseIncome',
          minWidth: 150
        },
        {
          title: '无门槛限时加费',
          align: 'center',
          key: 'platformActivityIncome',
          minWidth: 135
        },
        {
          title: '团队长管理费',
          align: 'center',
          key: 'baseLeaderIncome',
          minWidth: 170
        },
        {
          title: '其他活动收益',
          align: 'center',
          key: 'activityIncome',
          minWidth: 130
        },
        {
          title: '加扣款',
          align: 'center',
          key: 'deduction',
          minWidth: 130
        },
        {
          title: '税前合计',
          align: 'center',
          key: 'totalIncome',
          minWidth: 130
        },
        {
          title: '个税',
          align: 'center',
          key: 'tax',
          minWidth: 130
        },
      ])
      // ok保
      if(this.$units.isOkBao() || this.$units.isOkTX()) {
        columns = columns.concat([
          {
            title: '增值税',
            align: 'center',
            key: 'valueAddTax',
            minWidth: 130
          },
          {
            title: '附加税',
            align: 'center',
            key: 'additionalTax',
            minWidth: 130
          },
        ]);
      }
      columns = columns.concat([
        {
          title: '税后合计',
          align: 'center',
          key: 'costAmount',
          minWidth: 130
        },
        {
          title: '操作',
          slot: 'action',
          width: 190,
          align: 'center',
          fixed: 'right'
        }
      ]);
      this.columns = columns;
    }
  }
};
